import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Latestupdate from "../Component/Latestupdate/Latestupdate";
import FogotPassword from "Pages/ForgotPassword/Forgotpassword";

export default function ForgotPassTheme() {
  return (
    <>
    
      {/* <Header /> */}
      <FogotPassword />
      {/* <Latestupdate />
      <Footer /> */}
    </>
  );
}
